import React from "react";

export const CONFIG = {
    GET_APARTMENT_ADS_CATEGORIES: '/api/apartment/recommended/categories',
    GET_APARTMENT_ADS: '/api/apartment/recommended/',
    GET_APARTMENT_ADS_BY_CITY_NAME: '/api/apartment/recommended-city/',
    GET_LIKED_COUNT: '/api/apartment/liked',
}